// extracted by mini-css-extract-plugin
export default {"tableHeader":"Boxscore_tableHeader__jjwMn"};